import { render, staticRenderFns } from "./PersistRotaSlaView.vue?vue&type=template&id=6fd00d7e&"
import script from "./PersistRotaSlaView.vue?vue&type=script&lang=ts&"
export * from "./PersistRotaSlaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports